import React from "react";
import { connect } from "react-redux";
import hoistNonReactStatics from 'hoist-non-react-statics'
import {
  bankAccountActions
} from "../../../actions";

let loaded = false;

export const withBankAccessType = (WrapperComponent) => {
  class Enhance extends React.Component {
    componentDidMount() {
      const { getBankAccessType } = this.props;
      if (!loaded) {
        getBankAccessType()
      }
      loaded = true;
    }
  
    render() {
      return (
        <WrapperComponent 
          {...this.props} 
        />
      )
    }
  }
  const mapStateToProps = ({ bankAccount: {  bankAccessTypes } }) => ({ bankAccessTypes })
  const WithBankAccessType = connect(mapStateToProps, {
    getBankAccountType: bankAccountActions.getBankAccessType
  })(Enhance);
  hoistNonReactStatics(WithBankAccessType, WrapperComponent)
  return WithBankAccessType
}
